import { StandaloneProseProps } from '@/components/Prose';
import { propClassName } from '@/styles/Paragraph';
import { ClassNameProp, StandaloneComponent } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { standaloneComponent } from 'modules/dynamic-components';

const Prose = standaloneComponent<StandaloneProseProps>('ElementProse');

export interface ParagraphProps extends Omit<StandaloneProseProps, 'markup'> {
  content?: string;
  attributes?: Record<string, string>;
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const ParagraphComponent: StandaloneComponent<ParagraphProps> = ({
  content,
  attributes,
  colors,
  size,
  variant,
  options,
  ...props
}) => {
  const { className, ...baseProps } = options ?? {};

  const colorsClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);
  const variantClassName = propClassName('variant', variant);
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  const attrs =
    Object.entries(attributes ?? {})
      ?.map(([key, value]) => `${key}="${value}"`)
      ?.join(' ') ?? '';

  const markup = `<p ${attrs}>${content}</p>`;

  return <Prose options={{ className: componentClassName }} {...{ markup }} {...baseProps} {...props} />;
};

export const Paragraph = ParagraphComponent;
